import { useHistory } from 'react-router-dom'
import { useQueryClient } from 'react-query'

import { LOGIN_PATH } from 'paths'
import { useAuth } from './UseAuth'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { UserService } from 'api/clients/UserService'
import { useRootStore } from 'stores/RootStore'

export const useSession = () => {
  const history = useHistory()
  const auth = useAuth()
  const queryClient = useQueryClient()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const isAlmanacCore = currentWorkspaceId === ALMANAC_CORE_WORKSPACE_ID
  const featureFlags = useRootStore().featureFlags

  const logout = (attrs: { logoutRedirect?: string | null } = {}) => {
    const { logoutRedirect = LOGIN_PATH } = attrs

    UserService.unsetAuthCookie()
    featureFlags.clear()
    queryClient.invalidateQueries('featureFlags')

    if (logoutRedirect && history.location.pathname !== logoutRedirect) {
      history.replace(logoutRedirect)
    }
  }

  return {
    logout,
    auth,
    isAlmanacCore,
  }
}
